import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import toastr from "toastr";

// Login Redux States
import {
  ADD_PARTICIPANTS_REMINDERS,
  EDIT_PARTICIPANTS_REMINDERS,
  VIEW_PARTICIPANTS_REMINDERS,
  LIST_PARTICIPANTS_REMINDERS,
  DELETE_PARTICIPANTS_REMINDERS,
  ADD_PARTICIPANTS_REMINDERS_TEXT,
  EDIT_PARTICIPANTS_REMINDERS_TEXT,
  VIEW_PARTICIPANTS_REMINDERS_TEXT,
  LIST_PARTICIPANTS_REMINDERS_TEXT,
  DELETE_PARTICIPANTS_REMINDERS_TEXT
} from "./actionTypes"
import { participantsRemindersSuccess, participantsRemindersError } from "./actions"

import {
  onAddParticipantsReminders,
  onEditParticipantsReminders,
  onViewParticipantsReminders,
  onListParticipantsReminders,
  onDeleteParticipantsReminders,
  onAddParticipantsRemindersText,
  onEditParticipantsRemindersText,
  onListParticipantsRemindersText,
  onViewParticipantsRemindersText,
  onDeleteParticipantsRemindersText
} from "helpers/backend_api_helper";

// add 

function* addParticipantsReminders({ payload: { data, history, callback } }) {
  try {
    const response = yield call(onAddParticipantsReminders, data);
    yield put(participantsRemindersSuccess(response));
    callback && callback(response);
  } catch (error) {
    yield put(participantsRemindersError(error?.response?.data?.message || "Server Error"));
  }
}

// edit Invites
function* participantsEditReminders({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onEditParticipantsReminders, data, id);
    yield put(participantsRemindersSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(participantsRemindersError(error?.response?.data?.message || "Server Error"));
  }
}

// list Invites
function* listParticipantsReminders({ payload: { data, callback } }) {
  try {
    const response = yield call(onListParticipantsReminders, data);
    yield put(participantsRemindersSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(participantsRemindersError(error?.response?.data?.message || "Server Error"));
  }
}

// view Invites
function* participantsViewReminders({ payload: { data, history } }) {
  try {
    const response = yield call(onViewParticipantsReminders, data);
    yield put(participantsRemindersSuccess(response));

  } catch (error) {
    yield put(participantsRemindersError(error?.response?.data?.message || "Server Error"));
  }
}

// delete Invites
function* deleteParticipantsReminders({ payload: { data, callback } }) {
  try {
    const response = yield call(onDeleteParticipantsReminders, data);
    yield put(participantsRemindersSuccess(response));

    callback && callback(response);
  } catch (error) {
    yield put(participantsRemindersError(error?.response?.data?.message || "Server Error"));
  }
}


// text
// add Invites
function* addAspirationText({ payload: { data, callback } }) {
  try {
    const response = yield call(onAddParticipantsRemindersText, data);
    yield put(participantsRemindersSuccess(response));
    callback && callback(response);
  } catch (error) {
    toastr.error(error?.response?.data?.message);
    yield put(participantsRemindersError(error?.response?.data?.message || "Server Error"));
  }
}

// edit Invites
function* participantsEditRemindersText({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onEditParticipantsRemindersText, data, id);
    yield put(participantsRemindersSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(participantsRemindersError(error?.response?.data?.message || "Server Error"));
  }
}

// list Invites
function* listParticipantsRemindersText({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onListParticipantsRemindersText, data, id);
    yield put(participantsRemindersSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(participantsRemindersError(error?.response?.data?.message || "Server Error"));
  }
}

// view Invites
function* viewAspirationText({ payload: { data, history } }) {
  try {
    const response = yield call(onViewParticipantsRemindersText, data);
    yield put(participantsRemindersSuccess(response));

  } catch (error) {
    yield put(participantsRemindersError(error?.response?.data?.message || "Server Error"));
  }
}

// delete Invites
function* deleteAspirationText({ payload: { data, callback } }) {
  try {
    const response = yield call(onDeleteParticipantsRemindersText, data);
    yield put(participantsRemindersSuccess(response));

    callback && callback(response);
  } catch (error) {
    yield put(participantsRemindersError(error?.response?.data?.message || "Server Error"));
  }
}



function* InvitesSaga() {
  yield takeEvery(ADD_PARTICIPANTS_REMINDERS, addParticipantsReminders);
  yield takeEvery(EDIT_PARTICIPANTS_REMINDERS, participantsEditReminders);
  yield takeEvery(LIST_PARTICIPANTS_REMINDERS, listParticipantsReminders);
  yield takeEvery(VIEW_PARTICIPANTS_REMINDERS, participantsViewReminders);
  yield takeEvery(DELETE_PARTICIPANTS_REMINDERS, deleteParticipantsReminders);

  // text
  yield takeEvery(ADD_PARTICIPANTS_REMINDERS_TEXT, addAspirationText);
  yield takeEvery(EDIT_PARTICIPANTS_REMINDERS_TEXT, participantsEditRemindersText);
  yield takeEvery(LIST_PARTICIPANTS_REMINDERS_TEXT, listParticipantsRemindersText);
  yield takeEvery(VIEW_PARTICIPANTS_REMINDERS_TEXT, viewAspirationText);
  yield takeEvery(DELETE_PARTICIPANTS_REMINDERS_TEXT, deleteAspirationText);
}

export default InvitesSaga;

